import { matchPath } from "react-router-dom";

import {
  SHIFT_DISCOVERY_BASKET_SIZE_WILL_REACH_WARNING_MODAL_PATH,
  SHIFT_DISCOVERY_CHILDCARE_REFERRAL_PROMPT_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_ARRIVAL_TIME_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_AUCTION_CONFIRM_INSTANT_BOOK_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_AUCTION_PLACE_BID_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_AUCTION_REVIEW_BID_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_BOOKED_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_BREAK_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_BUNDLE_BOOKED_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_BUNDLE_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_BUNDLE_SELECT_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_CONFIRM_BOOKING_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_DOC_RESOLUTION_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_DOCUMENT_SUBMITTED_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_DOUBLE_BOOKED_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_DOUBLE_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_EDUCATE_ABOUT_CLIPBOARD_SCORE_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_EDUCATE_NEW_WORKER_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_HELLO_SIGN_CONTAINER_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_NEGOTIATION_CANCEL_MODAL_PATH,
  SHIFT_DISCOVERY_SHIFT_NEGOTIATION_MODAL_PATH,
} from "./paths";
import { type ShiftModalRoutePathParams } from "./types";

export function getShiftModalRouteParams<Params extends ShiftModalRoutePathParams>(
  baseNavigationPath: string,
  locationPathname: string
) {
  const match = matchPath<Params>(locationPathname, {
    path: [
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_DOUBLE_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_DOUBLE_BOOKED_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_BUNDLE_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_BUNDLE_SELECT_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_BUNDLE_BOOKED_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_BOOKED_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_EDUCATE_NEW_WORKER_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_CONFIRM_BOOKING_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_DOC_RESOLUTION_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_BREAK_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_BASKET_SIZE_WILL_REACH_WARNING_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_HELLO_SIGN_CONTAINER_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_DOCUMENT_SUBMITTED_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_ARRIVAL_TIME_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_AUCTION_CONFIRM_INSTANT_BOOK_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_AUCTION_PLACE_BID_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_AUCTION_REVIEW_BID_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_NEGOTIATION_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_NEGOTIATION_CANCEL_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_SHIFT_EDUCATE_ABOUT_CLIPBOARD_SCORE_MODAL_PATH}`,
      `${baseNavigationPath}/${SHIFT_DISCOVERY_CHILDCARE_REFERRAL_PROMPT_MODAL_PATH}`,
    ],
    exact: true,
    strict: false,
  });

  return match?.params;
}
